import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Environment } from '../../../models/environment.model';
import { Observable } from 'rxjs';
import { CollectionResponse } from '../../../models/api.model';
import { MatchesResponse } from '../models/api/matches-response.model';
import { MessagesResponse } from '../models/api/messsages-response.model';
import { AdminMatch, MatchTypeFilter } from '../models/admin-match.model';


@Injectable({
  providedIn: 'root'
})
export class MatchesService {

  constructor(
    private httpClient: HttpClient,
    @Inject('environment') private environment: Environment,
  ) { }

  getMatches(userId: number) {
    return this.httpClient.get<MatchesResponse>(`${this.environment.api.url}/admin/users/${userId}/matches`);
  }

  /** Every match in the system, paginated — powers the Matches table. */
  getAllMatches(
    query: string = null,
    page: number = 1,
    limit: number = 30,
    sort: string = null,
    type: MatchTypeFilter = 'all',
    hasMessages = false,
    showDeleted = false,
  ) {
    let params = new HttpParams();

    if (query) {
      params = params.append('query', `${query}`);
    }
    params = params.append('page', `${page}`);
    params = params.append('limit', `${limit}`);

    if (sort) {
      params = params.append('sort', `${sort}`);
    }
    if (type && type !== 'all') {
      params = params.append('type', `${type}`);
    }
    if (hasMessages) {
      params = params.append('has_messages', 'true');
    }
    if (showDeleted) {
      params = params.append('show_deleted', 'true');
    }

    return this.httpClient.get<CollectionResponse<AdminMatch>>(`${this.environment.api.url}/admin/matches`, {
      params
    });
  }

  getMessages(matchId: number) {
    return this.httpClient.get<MessagesResponse>(`${this.environment.api.url}/admin/matches/${matchId}/messages`);
  }
}
